import React from "react";
import { useSelector } from "react-redux";
import classes from './AssessmentFeedback.module.css';
import * as SubmissionStatusEnum from "../models/SubmissionStatus";

const AssessmentFeedback = ({ submissionStatusId, remarks, SCORE_EXAMPLE, scoreAdditionalData, dropClass, submittedByUser }) => {

    const { texts, direction, lang } = useSelector(state => state.translate);

    return (
        <div className={dropClass}>
            <p className={classes.Title}>{texts.appreciation}</p>
            <div className={classes.StatusContainer}>


                {remarks && <>
                    {submittedByUser?.isGroup &&
                        <div className={classes.AssessmentForTeam}>{texts.assessmentFor} {submittedByUser.name}: {submittedByUser.users.map(u => u.firstName + ' ' + u.lastName).join(', ')}</div>}
                    <div
                        className={classes.StudentScoreFeedback}
                        dir={direction}
                        ref={(el) => { if (el) el.innerHTML = remarks }}
                        id="froalaViewer">
                    </div>
                    <hr />
                </>}

                {submissionStatusId !== SubmissionStatusEnum.rejected && scoreAdditionalData ?
                    <>
                        <div className={classes.ScoreContainer}>
                            {scoreAdditionalData?.ScoreType == 'numScore' ?
                                <div>
                                    <p className={classes.weightedScoreText}>{texts.weightedScoreToAssessment}</p>
                                    <p className={classes.weightedScore}>{Math.round(scoreAdditionalData?.weightedScore)}</p>
                                </div>
                                :
                                <div>
                                    <p className={classes.weightedScoreText}>{texts.verbalFeedbackToAssessment}</p>
                                    <div>{scoreAdditionalData.verbalFeedbackText}</div>
                                </div>
                            }
                        </div>

                        <hr />

                        {scoreAdditionalData.hasOwnProperty('verbalFeedbackText') && scoreAdditionalData?.ScoreType == 'textScore' ?
                            ''
                            :
                            <div className={classes.AdditionalDataContainer}>
                                <p className={classes.weightedScoreText}>{texts.scoreDetails}</p>
                                {Object.entries(scoreAdditionalData).map(([key, value], index) => {
                                    if (key != "verbalFeedbackText" && key != "weightedScore" && key != "ScoreType" && value) {
                                        return (<React.Fragment key={key}>
                                            {scoreAdditionalData.ScoreType === 'textScore' ?

                                                <div key={key} className={classes.DynamicScoreTextContainer}>
                                                    <p className={classes.DynamicScoreText}>{SCORE_EXAMPLE?.find(x => x.criteria[lang] === key)?.appreciationOption[value]?.text[lang]}</p>
                                                </div>
                                                :
                                                <>
                                                    <div key={key} className={classes.DynamicScoreContainer}>
                                                        <p>{key}</p>
                                                        <p className={classes.DynamicScoreScore}> {value} </p>
                                                    </div>
                                                    {index + 1 < Object.keys(scoreAdditionalData).length - 1 && <hr />}
                                                </>
                                            }
                                        </React.Fragment>)
                                    }
                                })}
                            </div>
                        }
                    </>
                    : ''
                }
            </div>
            <div className={classes.VerticalHr}></div>
        </div >
    )
}

export default AssessmentFeedback;